// Push notification module constants
export const NOTIFICATION_ROUTES = {
  ROOT: "/notifications",
  TEMPLATES: "/notifications/templates",
  CAMPAIGNS: "/notifications/campaigns",
  JOBS: "/notifications/jobs",
  DEVICES: "/notifications/devices",
  ANALYTICS: "/notifications/analytics",
};

export const NOTIFICATION_API_ENDPOINTS = {
  // Templates
  GET_TEMPLATES: "/templates",
  CREATE_TEMPLATE: "/templates",
  CLONE_TEMPLATE: "/templates/:key/clone",
  ARCHIVE_TEMPLATE: "/templates/:key/:version/archive",
  UNARCHIVE_TEMPLATE: "/templates/:key/:version/unarchive",
  VALIDATE_TEMPLATE: "/templates/validate",
  GET_TEMPLATE_BY_KEY: "/templates/:key",
  GET_TEMPLATE_USAGE: "/templates/:key/usage",

  // Campaigns & Jobs
  SEND_CAMPAIGN: "/send",
  GET_JOBS: "/jobs",
  GET_JOB_DETAILS: "/jobs/:id",
  GET_JOB_AUDITS: "/jobs/:id/audits",
  CANCEL_JOB: "/jobs/:id/cancel",
  RETRY_JOB: "/jobs/:id/retry",

  // Devices (Admin)
  GET_DEVICES: "/admin-devices",
  TOGGLE_DEVICE: "/admin-devices/:id/toggle",

  // Analytics
  GET_ANALYTICS_KPIS: "/analytics/kpis",
  GET_ANALYTICS_CHART: "/analytics/chart",

  // Internal triggers
  TRIGGER_INSTALLMENT: "/trigger/installment",
};

export const NOTIFICATION_PERMISSIONS = {
  VIEW: "NOTIFICATION_VIEW",
  ADMIN: "NOTIFICATION_ADMIN",
  SUPERADMIN: "SUPERADMIN",
};

// Validation schema names (matching Joi schemas)
export const VALIDATION_SCHEMAS = {
  DEVICE_REGISTRATION: "deviceRegistration",
  DEVICE_UPDATE: "deviceUpdate",
  DEVICE_REFRESH: "deviceRefresh",
  TOGGLE_DEVICE: "toggleDevice",
  INVALIDATE_TOKEN: "invalidateToken",
  TEMPLATE: "template",
  ARCHIVE_TEMPLATE: "archiveTemplate",
  TEMPLATE_VALIDATE: "templateValidate",
  SEND_NOTIFICATION: "sendNotification",
  TRIGGER_INSTALLMENT: "triggerInstallment",
  PROVIDER_WEBHOOK: "providerWebhook",
};
